// removed by extract-text-webpack-plugin
module.exports = {"button":"_3B4BHf6AYs9fOJaDpEGUXt","done":"_21hp0746gV3cDY_bxc-Kkq"};


//////////////////
// WEBPACK FOOTER
// ./src/Pages/CreatePasswordPage/CreatePasswordPage.css
// module id = 649
// module chunks = 3